import { PathBreadcrumb, type PathPart } from '@festina-life/ui/structure'
import { useMemo } from 'react'

import type { ConfigurationItem } from '../../types/common'
import { ConfigurationItemIcon } from '../configurationItemIcon/ConfigurationItemIcon'

type Props = {
  value: string
  type: ConfigurationItem
}

export const SimplePath = ({ value, type }: Props) => {
  const parts = value.split('.')

  const pathParts = useMemo<PathPart[]>(
    () =>
      parts.map((part, index) => ({
        label:
          index === 0 ? (
            <div className="flex items-center gap-x-2">
              <ConfigurationItemIcon type={type} />
              {part}
            </div>
          ) : (
            part
          ),
      })),
    [parts, type],
  )

  return <PathBreadcrumb parts={pathParts} />
}
